import React from 'react';
import './AboutValuesSection.css';

const values = [
  {
    icon: '/icons/respect.webp',
    name: 'RESPECT'
  },
  {
    icon: '/icons/benefit1.webp',
    name: 'CONTINUOUS LEARNING'
  },
  {
    icon: '/icons/grounded.webp',
    name: 'GROUNDED CREATIVITY'
  },
  {
    icon: '/icons/transparency.webp',
    name: 'TRANSPARENCY'
  },
  {
    icon: '/icons/excellence.webp',
    name: 'EXCELLENCE'
  },
  {
    icon: '/icons/collaboration.webp',
    name: 'COLLABORATION'
  },
  {
    icon: '/icons/ownership.webp',
    name: 'OWNERSHIP & ACCOUNTABILITY'
  }
];

const AboutValuesSection = () => {
  return (
    <section className="aboutvalues-section" id="values">
      <div className="container">
      <div className="aboutvalues-content-wrapper">
        {/* Header Area */}
        <div className="aboutvalues-header">
          <div className="aboutvalues-heading">
            <h1>
              <span className="aboutvalues-heading-part1">THE VALUES THAT</span>
              <span className="aboutvalues-heading-part2">DRIVE US</span>
            </h1>
          </div>
          <div className="aboutvalues-intro">
            <p>We live by our values; they guide our efforts and define our culture.</p>
          </div>
        </div>

        {/* Values Grid */}
        <div className="aboutvalues-grid">
          {values.map((value, idx) => (
            <div className="aboutvalues-value-card" key={idx}>
              <div className="aboutvalues-icon">
  <img src={value.icon} alt={value.title + ' icon'} />
</div>
              <div className="aboutvalues-value-name">{value.name}</div>
            </div>
          ))}
        </div>

        {/* Call to Action Button */}
        
      </div>
      </div>
    </section>
  );
};

export default AboutValuesSection;